import React from 'react';
import { useInView } from 'react-intersection-observer';
import { FaPhone, FaEnvelope, FaGlobe, FaMapMarkerAlt } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  const contactInfo = [
    {
      icon: FaPhone,
      title: "Phone",
      value: "+31 50 36 33768",
      link: "tel:+31503633768"
    },
    {
      icon: FaEnvelope,
      title: "Email",
      value: "s.mansouri@rug.nl",
      link: "mailto:s.mansouri@rug.nl"
    },
    {
      icon: FaGlobe,
      title: "Web",
      value: "https://www.rug.nl/staff/s.mansouri",
      link: "https://www.rug.nl/staff/s.mansouri"
    },
    {
      icon: FaMapMarkerAlt,
      title: "Office",
      value: "Duisenberg Building (801), Nettelbosje 2, 9747 AE Groningen, NL",
      link: null
    }
  ];

  return (
    <section id="contact" className="contact section" ref={ref}>
      <div className="container">
        <div className="section-title">
          <h2>Contact Me</h2>
          <p>Get in touch for academic collaborations, research discussions, or student supervision</p>
        </div>

        <div className="contact-content">
          <div className={`contact-info ${inView ? 'fade-in' : ''}`}>
            <div className="contact-header">
              <h3>Academic Office</h3>
              <p>University of Groningen</p>
            </div>

            <div className="contact-details">
              {contactInfo.map((info, index) => (
                <div key={index} className="contact-item">
                  <div className="contact-icon">
                    <info.icon />
                  </div>
                  <div className="contact-text">
                    <h4>{info.title}</h4>
                    {info.link ? (
                      <a href={info.link} target="_blank" rel="noopener noreferrer">
                        {info.value}
                      </a>
                    ) : (
                      <p>{info.value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="contact-note">
              <p>
                <strong>Office Hours:</strong> By appointment. Please email to schedule a meeting.
              </p>
              <p>
                <strong>Research Collaboration:</strong> I'm always interested in discussing potential 
                research collaborations in the areas of financial data science, ESG, and machine learning applications.
              </p>
              <p>
                <strong>Student Supervision:</strong> I welcome inquiries from students interested in 
                bachelor's or master's thesis supervision in my research areas.
              </p>
            </div>
          </div>

          <div className={`contact-visual ${inView ? 'slide-in-right' : ''}`}>
            <div className="contact-card">
              <div className="card-header">
                <h3>Quick Contact</h3>
                <p>Preferred method of contact</p>
              </div>
              <div className="card-content">
                <div className="contact-method">
                  <div className="method-icon">
                    <FaEnvelope />
                  </div>
                  <div className="method-info">
                    <h4>Email</h4>
                    <p>For academic inquiries, research collaboration, and student supervision</p>
                    <a href="mailto:s.mansouri@rug.nl" className="btn btn-primary">
                      Send Email
                    </a>
                  </div>
                </div>
                
                <div className="contact-method">
                  <div className="method-icon">
                    <FaPhone />
                  </div>
                  <div className="method-info">
                    <h4>Phone</h4>
                    <p>For urgent matters or scheduled calls</p>
                    <a href="tel:+31503633768" className="btn btn-secondary">
                      Call Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 